<script>
  import { Slider } from '$client';
  import Item from './Item.svelte';
  export let data = [];
  export let type = 'purple';
  export let header = 'Достижения экотакси «Убери»';
  export let buttons = true;
  export let url = '';

  const media = [
    { size: 99999, gap: 40, count: 4 },
    { size: 1199.98, gap: 20, count: 3 },
    { size: 991.98, gap: 15, count: 2 },
    { size: 767.98, gap: 15, count: 1 },
  ];
</script>

<Slider {url} {buttons} {header} {type} component={Item} {data} {media} />
